import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';
import Loader from '../../components/Loader';
import { withStyles } from '@material-ui/core/styles';
import Follower from '../../components/NewFollowerCard';
// import Pagination from '../../components/Pagination';
import { Typography } from '@material-ui/core';
import VerticalSliders from '../../components/VerticalSlider';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  about_body: {
    // margin: theme.spacing.unit,
    // marginTop: theme.spacing.unit + 7,
    color: '#2d2b2bb0',
    // padding: '20px 0 20px 10px',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  button: {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    border: '1px solid ' + theme.palette.primary.main,
    borderRadius: '2px',
    margin: '2px',
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
});

const response = {
  pageable: {
    offset: 0,
    pageNumber: 1,
    pageSize: 2,
  },
  numberOfElements: 4,
  followers: [
    {
      username: 'Person 1',
      articleCount: 10,
      expertsIn: ['dfgdfg', 'ghfghhg', 'bhjhjghj'],
    },
    {
      username: 'Person 2',
      articleCount: 10,
      expertsIn: ['dfgdfg', 'ghfghhg', 'bhjhjghj'],
    },
  ],
};
const response2 = {
  pageable: {
    offset: 0,
    pageNumber: 2,
    pageSize: 2,
  },
  numberOfElements: 4,
  followers: [
    {
      username: 'Person 3',
      articleCount: 100,
      expertsIn: ['dfgdfg', 'ghfghhg', 'bhjhjghj'],
    },
    {
      username: 'Person 4',
      articleCount: 14,
      expertsIn: ['dfgdfg', 'ghfghhg', 'bhjhjghj'],
    },
  ],
};

const FollowCards = ({ followerData }) => {
  let displayCards = followerData.map((follower, i) => {
    return (
      <Follower
        key={follower.userName}
        style={{ margin: '15px 0px' }}
        id={follower.id}
        username={follower.displayName ? follower.displayName : ''}
        articleCount={follower.articleCount ? follower.articleCount : ''}
        profilePic={follower.profilePic.uri}
        expertsIn={
          follower.cuisinesOfExpertise ? follower.cuisinesOfExpertise : ''
        }
      />
    );
  });
  return <VerticalSliders>{displayCards}</VerticalSliders>;
};

class ListFollowers extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    response: response,
    pageNumber: 21,
    pageSize: 10,
    totalElements: 201,
  };
  componentDidMount() {
    this.props.dispatch(actions.getData());
  }
  handlePageChange(pageNumber) {
    if (pageNumber === 1) {
      this.setState({ response });
    } else if (pageNumber === 2) {
      this.setState({ response: response2 });
    }
  }
  render() {
    const { classes, loading, followers } = this.props;
    console.log(followers);
    if (loading) {
      return <Loader />;
    } else {
      return (
        <div style={{ padding: '5% 3%' }}>
          {followers.content.length > 0 ? (
            <Typography
              component="h2"
              variant="h5"
              className={classes.about_body}
            >
              My Followers
            </Typography>
          ) : (
            <Typography
              component="h2"
              variant="h5"
              className={classes.about_body}
            >
              You don't have followers
            </Typography>
          )}
          <br />
          <FollowCards followerData={followers.content} />
          <br />
          {/* old done by Shivam <Pagination
            pageNumber={this.state.response.pageable.pageNumber}
            pageSize={this.state.response.pageable.pageSize}
            totalElements={this.state.response.numberOfElements}
            onChange={this.handlePageChange}
          /> */}

          {/* <Pagination
            pageNumber={followers.totalPages}
            pageSize={2}
            totalElements={followers.numberOfElements}
            onChange={this.handlePageChange}
            content={followers.content}
          /> */}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(ListFollowers));
